import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaginatedSearchResultMatchSearchResultDTO } from '@solverml/api';

import { StatisticsMatchCardComponent } from '../statistics-match-card/statistics-match-card.component';

/**
 * Componente "Dumb" (Vista) que muestra la lista paginada
 * de partidos de un equipo para una temporada.
 */
@Component({
  selector: 'app-team-match-list',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    StatisticsMatchCardComponent
  ],
  templateUrl: './team-match-list.component.html',
  styleUrls: ['./team-match-list.component.scss']
})
export class TeamMatchListComponent {

  /**
   * El resultado paginado de los partidos.
   */
  @Input({ required: true }) matchesResult!: PaginatedSearchResultMatchSearchResultDTO | null;

  /**
   * Indica si se están cargando los datos de esta sección.
   */
  @Input({ required: true }) isLoading!: boolean | null;

  /**
   * Evento emitido cuando el usuario cambia de página.
   */
  @Output() pageChanged = new EventEmitter<number>();

  /**
   * Manejador del evento (page) del <mat-paginator>.
   * @param event El evento de paginación.
   */
  onPageChange(event: PageEvent): void {
    // mat-paginator usa índice 0, la API usa índice 1
    this.pageChanged.emit(event.pageIndex + 1);
  }
}
